import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Shield } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const { user } = useAuth();

  if (user) {
    const STAFF = ['super_admin', 'admin', 'deal_manager', 'content_manager', 'investor_relations', 'view_only'];
    if (STAFF.includes(user.role)) return <Navigate to="/admin" replace />;
    if (user.status === 'pending' || user.status === 'rejected') return <Navigate to="/pending" replace />;
    return <Navigate to="/portal" replace />;
  }

  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/portal';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="mb-12">
          <h1 className="text-4xl text-[#A0743A] mb-2 tracking-tight">SÀWAI CAPITAL</h1>
          <div className="w-16 h-[1px] bg-[#C9A96E] mx-auto mb-4" />
          <p className="text-sm uppercase tracking-[0.2em] text-[#C9A96E]">Dealroom</p>
        </div>

        <div className="border border-[#A0743A]/30 p-10 bg-[#1A1A1A]">
          <Shield className="w-10 h-10 text-[#A0743A] mx-auto mb-6" strokeWidth={1.25} />
          <h2 className="text-2xl text-[#FAF8F5] mb-3">Investor Access</h2>
          <p className="text-[#999] mb-8 text-sm leading-relaxed">
            Sign in with your Google account to access curated private market opportunities.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="w-full bg-[#A0743A] text-[#FAF8F5] px-8 py-3.5 font-semibold transition-colors hover:bg-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E] focus:outline-none text-sm uppercase tracking-wider"
          >
            Sign in with Google
          </button>

          <p className="text-[#555] text-xs mt-6 leading-relaxed">
            Access is restricted to verified investors only. By signing in, you agree to our terms of access.
          </p>
        </div>
      </div>
    </div>
  );
}
